import { Components, Theme } from '@mui/material/styles';

export const MuiButton: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: {
      backgroundColor: 'var(--palette-primary-main)',
      color: 'var(--palette-text-primary)',
    },
    contained: {
      borderRadius: '3px',
      gap: '0.5rem',
      '&:hover': {
        backgroundColor: 'var(--palette-action-hover)',
      },
    },
  },
};
